"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.LocationPrompt = void 0;
var _locationPrompt = _interopRequireDefault(require("./components/location-prompt"));
exports.LocationPrompt = _locationPrompt["default"];